export const TRANSITION_DURATION = 200;
